import React, { useState, useEffect, useCallback } from "react";
import { Redirect, useNavigate, useParams } from "react-router-dom";
import FormSuccess from "../../Components/SharedComponent/FormSuccess/FormSuccess";
import "../../Components/SharedComponent/FormSuccess/FormSuccess.scss";
import SalesService from "../../Services/SalesService";
import { OverlayLoader } from "../../Components/Loader/Loader";
/**
 * UserProjects Component displays a list of projects assigned to user.
 *
 * @component
 */
const FormSuccessPage = () => {
  const { id: formId } = useParams();
  const [formData, setFormData] = useState(null);
  const [parsedData, setParsedFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFormData = async () => {
      try {
        const response = await SalesService.fetchSale(formId);
        setFormData(response.data.data[0]);
        const parsedFormData = JSON.parse(response.data.data[0]?.form_data);
        setParsedFormData(parsedFormData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching form data:", error);
      }
    };
    if (formId) {
      fetchFormData();
    }
  }, [formId]);

  if (formId && formData?.form_status_id == 1) {
    return navigate("/not-found");
  }
  return (
    <React.Fragment>
      <div className="form_Success_page_container">
        <div className="form_Success_wrap">
          <FormSuccess
            parsedData={parsedData}
            formData={formData}
            formId={formId}
          />
        </div>
      </div>
      {loading && <OverlayLoader />}
    </React.Fragment>
  );
};

export default FormSuccessPage;
